import type { AccessResource } from '@web/types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FunctionComponent, ElementType } from 'react'

export interface AccessState {
  level1Links: AccessResource[]
  level2Links: AccessResource[]
  routes: IRouteNode[]
}

export interface IRouteNode extends AccessResource {
  path: string
  isRoot: boolean
  options?: {
    staticData?: {
      metaRoute?: {
        title: string
        description?: string
        order?: number
        hidden?: boolean
        icon?: FunctionComponent<any> | ElementType
      }
    }
  }
  children?: IRouteNode[]
}

const initialState: AccessState = {
  level1Links: [],
  level2Links: [],
  routes: [],
}

const accessSlice = createSlice({
  name: 'access',
  initialState,
  reducers: {
    setRoutes: (state, { payload }: PayloadAction<IRouteNode[]>) => {
      state.routes = payload

      // Mapeamos los links de Nivel 1 (Módulos)
      state.level1Links = payload
        .filter((link) => link.level === 1)
        .map((route) => ({
          ...route,
          text: route.options?.staticData?.metaRoute?.title || route.path,
          icon: route.options?.staticData?.metaRoute?.icon,
        }))

      // Mapeamos los links de Nivel 2 (Recursos) extrayéndolos de los hijos de los padres
      state.level2Links = payload.reduce<AccessResource[]>((acc, curr) => {
        const childrenLinks =
          curr.children
            ?.map((child) => ({
              ...child,
              parentRouteId: curr.id, // Vínculo necesario para el Sidebar rediseñado
              text: child.options?.staticData?.metaRoute?.title || child.path,
              icon: child.options?.staticData?.metaRoute?.icon,
            } as AccessResource)) || []
        return [...acc, ...childrenLinks]
      }, [])
    },
  },
  selectors: {
    level1Links: (state) => state.level1Links,
    level2Links: (state) => state.level2Links,
    routes: (state) => state.routes,
  },
})

export const accessActions = accessSlice.actions
export const accessSelectors = accessSlice.selectors
export const accessReducer = { [accessSlice.name]: accessSlice.reducer }